import './RejectedOfferInfo.scss';
import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import DealerConnect from '../../../components/DealerConnect/DealerConnect';
import {tagUnsuccessfulPrequalifiedResultView} from '../../../Services/TaggingService/TaggingService';
import TimeOutSession from '../../../components/TimeOutSession/TimeOutSession';
import {closeTier3ModalEvent} from '../../../utils/tier-3-modal-close/PrequalCloseEvent';
import {submitDealerSearch} from '../../../Services/SubmitDealerSearchService/SubmitDealerSearchService';
import {timeFormat} from '../../../utils/functions/Functions';
import {trackEvents} from '../../../Services/OptimizelyService/OptimizelyService';
import {getQueryElement} from '../../../utils/queryElement';
import {AccordionPanel} from '../../../components/Accordion/AccordionPanel';
import {FormHeaderSection} from '../../PrequalSinglePageApp/FormHeaderSection/FormHeaderSection';

const faqDropDownValues = [
  {
    title: 'Why doesn’t prequalification affect my credit score?',
    content:
      'Because you’re not applying for credit, it will not affect your credit score. Instead, prequalification requires you to report your income and personal information, and then a soft credit inquiry is made.',
    border: true
  },
  {
    title: 'Can I try prequalifying again if I couldn’t get an offer the first time?',
    content: 'If we’re unable to return an amount, please wait 30 days and try again.'
  }
];

function RejectedOfferInfo({result, customerData, appConfig, dispatch}) {
  const navigate = useNavigate();
  const [dealerDetails, setDealerDetails] = useState({});

  useEffect(() => {
    if (!customerData.isDealerHostApplication.value) {
      getQueryElement(customerData).getElementById('prequal--web--app').scrollIntoView();
    }
    if (customerData.isDealerHostApplication.value) {
      const getDealerDetails = async () => {
        const searchCriteria = {
          searchString: customerData?.tier3PACode?.value,
          searchType: 'DETAILS',
          customerUUID: customerData.uuid
        };
        const searchResult = await submitDealerSearch(searchCriteria, appConfig);
        if (searchResult?.dealers?.length > 0) {
          setDealerDetails(searchResult.dealers[0]);
        }
      };
      getDealerDetails();
    }

    if (customerData.prequalSource.value === 'web' && customerData?.recaptchaOptimizelyData?.isEnabled) {
      trackEvents('Decision Page View', customerData);
    }
    const {offerId} = result;
    tagUnsuccessfulPrequalifiedResultView(offerId, customerData);
  }, []);

  function closeEvent() {
    closeTier3ModalEvent({}, dispatch, customerData);
  }

  return (
    <>
      <div hidden data-testid='offer-id'>
        {result?.offerId}
      </div>
      {customerData.isDealerHostApplication.value ? (
        <>
          <FormHeaderSection
            isDealerHostApplication
            dispatch={dispatch}
            customerData={customerData}
            navigate={navigate}
            headerText='Prequalify for financing in no time at all.'
          />
          <div className='prequal--wc--rejected-container' data-testid='rejected-offer-container'>
            <div className='prequal--wc--dealer-can-help-text-title'>Your Dealer Can Help</div>
            <h2 className='prequal--wc--delear-can-help-text'>
              We’re unable to provide you with a prequalified offer online, but you can still visit your local dealer.
            </h2>
            <div className='prequal--wc--why-not-approved-text-title'>Why Didn’t I Get Approved?</div>
            <div className='prequal--wc--why-not-approved-text'>
              This can happen for several reasons, and you should receive a letter in the mail with further explanation. Your local Ford
              dealer has financial experts on-site ready to help you.
            </div>
            {dealerDetails?.dealerName && (
              <>
                <hr className='prequal--wc--section-separator' />
                <div className='prequal--wc--visit-dealer-text'>In The Meantime, Visit {dealerDetails?.dealerName} for help.</div>
                <div className='prequal--wc--dealer-name'>
                  <a href={dealerDetails?.dealerWebsiteUrl} target='_blank' rel='noreferrer'>
                    {dealerDetails?.dealerName}
                  </a>
                </div>
                <div className='prequal--wc--dealer-details'>
                  <a href={dealerDetails?.dealerWebsiteUrl} target='_blank' rel='noreferrer' className='prequal--wc--dealer-address-link'>
                    <span>{dealerDetails?.dealerAddress?.streetAddress}</span>
                    <span>
                      {dealerDetails?.dealerAddress?.city}, {dealerDetails?.dealerAddress?.state} {dealerDetails?.dealerAddress?.postalCode}
                    </span>
                  </a>
                  <span className='prequal--wc--sales-hours'>
                    {dealerDetails?.dealerDistance && <>{dealerDetails?.dealerDistance} miles |&nbsp;</>}
                    {dealerDetails.dealerClosingTime && dealerDetails.dealerClosingTime !== '' && (
                      <>
                        Sales until&nbsp;
                        {timeFormat(dealerDetails.dealerClosingTime)}
                      </>
                    )}
                  </span>
                  <a href={`tel:${dealerDetails?.dealerPhone}`} className='prequal--wc--dealer-phone-link'>
                    <span>{dealerDetails?.dealerPhone}</span>
                  </a>
                </div>
              </>
            )}
            <div className='prequal--wc--offer-close'>
              <button
                type='button'
                className='prequal--web--submit-prequalification-button prequal--wc--offer-close-button'
                onClick={closeEvent}
              >
                Close
              </button>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='prequal--web--rejected-container' data-testid='offer-container'>
            {customerData.countryCode?.value === 'CAN' ? (
              <div className='prequal--web--rejection-message-canada'>
                <h1 className='prequal--web--rejection-message-header prequal--web--p--b-1'>We Hit A Roadblock</h1>
                <div className='prequal--web--rejected-message-container'>
                  <div className='prequal--web--rejected-message-paragraph prequal--web--rejected-message-first-paragraph'>
                    At this time, We are unable to provide you with a prequalified offer.
                  </div>
                  <div className='prequal--web--rejected-message-paragraph prequal--web--rejected-message-second-paragraph'>
                    This decision is based on the information you submitted along with the personal credit profile obtained from the credit
                    reporting agency. If you wish to review the accuracy of the information received from the credit reporting agency, you
                    may contact TransUnion: Attention Customer Relation P.O Box 338, LCD1 Hamilton, ON, L8L 7W2. Phone:{' '}
                    <a href='tel:1-800-663-9980'>1-800-663-9980</a> &nbsp; Website:{' '}
                    <a href='https://www.transunion.ca/' target='_blank' rel='noreferrer'>
                      www.transunion.ca
                    </a>
                  </div>
                  {customerData.stateOrProvince?.value === 'QC' && (
                    <div className='prequal--web--rejected-message-paragraph  prequal--web--rejected-message-third-paragraph'>
                      This decision was based on the automated processing of your Information. Should you wish to inquire about an automated
                      decision you may contact our Customer Service Centre at Box 1800 RPO Lakeshore West, Oakville, Ontario, L6K 0J8.
                      Attention: Privacy Office
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className='prequal--web--rejection-message'>
                <h1 className='prequal--web--rejection-message-header prequal--web--p--b-1'>We Hit A Roadblock</h1>
                <div className='prequal--web--rejection-message-content'>
                  At this time, we are unable to provide you with a prequalified offer. This can happen for several reasons, and you should
                  receive a letter in the mail with further explanation.
                </div>
              </div>
            )}
            <div className='prequal--web--dealer-search-section'>
              <div className='prequal--web--visit-dealer'>
                <div className='prequal--web--visit-dealer-title'>Your Dealer Can Help</div>
                <p className='prequal--web--visit-dealer-content'>
                  Your local Ford dealer has financial experts on-site ready to help you.
                </p>
              </div>
              <div className='prequal--web--dealer-search'>
                <DealerConnect dispatch={dispatch} customerData={customerData} appConfig={appConfig} hasSelectButton={false} />
              </div>
            </div>
          </div>
          <div className='prequal--web--faq-container'>
            <AccordionPanel accordionDropDownValues={faqDropDownValues} accordionTitle='Frequently Asked Questions' />
          </div>
          <TimeOutSession appConfig={appConfig} dispatch={dispatch} customerData={customerData} navigate={navigate} />
        </>
      )}
    </>
  );
}

export default RejectedOfferInfo;
